import { Box, IconButton, SxProps, Typography, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
// import { colors } from '../../constants/colors';
import { getToken } from "../../utils/app.utils";
import { useLocation } from "react-router-dom";
import PreviewImage from "../preview-image/PreviewImage";
import defaultFile from "./file_upload.svg";
import { IconComponent } from "../../assets/icons/iconComponent";
import { useTranslation } from "react-i18next";

const ImageContainer = styled("div")({
  width: "100%",
  height: "100%",
  minHeight: "189px",
  backgroundImage: ` url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='11' ry='11' stroke='%23C1C3C7' stroke-width='4' stroke-dasharray='2%2c 8' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e")`,
  borderRadius: "10px",
  marginTop: "0.5rem",
  display: "flex",
  padding: "12px",
  gap: "8px",
  flexWrap: "wrap",
});
export type ImageTrackingProps = {
  disableHeading?: boolean;
  heading?: string;
  subheading?: string;
  headingVariant?:
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "body1"
  | "body2"
  | "subtitle1"
  | "subtitle2";
  onChange: (data: any, mainIndex: number) => void;
  onFileOnly?: boolean;
  valueImage: any[];
  valueAddFile: any[];
  tabIndex: number;
  handleDeleteImageApi: (
    mainIndex: number,
    fileIndex: number,
    data: any
  ) => void;
  handleDeleteImageSelect: (mainIndex: number, imgIndex: number) => void;
  handleDownloadFile?: (data: any) => void;
  handleShowImageWithIndex?: (index_file: number) => void;
  enableAllType?: boolean;
  disabled?: boolean;
  sxHeading?: SxProps;
  required?: boolean;
  onDownloadFileButton?: (data: any) => void;
  onViewFileButton?: () => void;
  onUploadMedia?: () => void;
  addImageIcon?: React.ReactNode;
  is_using_modal_media?: boolean;
  base_image_url_api?: string;
};

const ImageTracking: React.FC<ImageTrackingProps> = (props: ImageTrackingProps) => {
  const { t } = useTranslation();
  // const token = getToken();
  const image_url = props.base_image_url_api ? props.base_image_url_api : process.env.REACT_APP_FILE_BASE_API_URL;
  const uniqueId = `upload-image-project-status-${props.tabIndex}`;

  // console.log(image_url)
  const location = useLocation();
  const isViewCheck: boolean = location.pathname.includes("view");
  // const [fileImage, setFileImage] = useState<File[]>(props.valueAddFile);
  const [pathUrl, setPathUrl] = useState<any>(null);
  // console.log(pathUrl)

  // console.log(pathUrl,'pathUrl')
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      if (files.length > 1) {
        // console.log(Array.from(files).map((file) => ({
        //     file,
        //     is_image: file.type.startsWith("image/"),
        // })));
        props.onChange(
          Array.from(files).map((file) => ({
            file,
            is_image: file.type.startsWith("image/"),
            status: "active",
          })),
          props.tabIndex
        );
      } else {
        // console.log(files)
        if (files?.length > 0) {
          const obj = {
            file: files[0],
            is_image: files[0]?.type.startsWith("image/"),
            status: "active",
          };
          props.onChange(obj, props.tabIndex);
        }
        // is_image: file.type.startsWith("image/"),
      }
    }
  };

  // console.log(props.valueImage, 'valueAddFile')

  useEffect(() => {
    const init = async () => {
      const response = await fetch("/resources/config.json");
      const results = await response.json();
      setPathUrl(results);
    };
    init();
  }, []);

  // ตัวอย่าง onChange ####################################################

  // const handleChangeFileImage = (newFile: any, mainIndex: number) => {
  //     const newArray = Array.isArray(newFile) ? newFile : [newFile];
  //     if (newFile?.length > 0) {
  //         setFile([...file, ...newArray])
  //     } else {
  //         setFile([...file, newFile])
  //     }
  // }

  return (
    <section className="w-full mt-1">
      {props.heading && (
        <article className="w-full flex justify-start items-center gap-2">
          <Typography
            sx={props.sxHeading}
            variant={props.headingVariant ? props.headingVariant : undefined}
          >
            {props.heading}
          </Typography>
          {props.required && <Typography sx={{ color: "red" }}>*</Typography>}
          {props.subheading && <Typography sx={{ color: "#828282" }}>{props.subheading}</Typography>}
        </article>
      )}
      <article>
        <ImageContainer>
          {props.onFileOnly ? (
            <></>
          ) : (
            <>
              {props.valueImage.length > 0 &&
                props.valueImage?.map((list: any, index: number) => {
                  // const file: any = list?.file;
                  const fileName = list?.file_name ? list?.file_name?.substring(0, 6) + "../" : list?.file?.file_name?.substring(0, 6);
                  const fileMediaName = list?.media_file_name ? list?.media_file_name?.substring(0, 6) + "../" : list?.file?.media_file_name?.substring(0, 6);
                  const fileNameDownload = list?.name ? list?.name?.substring(0, 6) + "../" : list?.file?.name?.substring(0, 6);
                  const fileExtension = list?.file_name ? list?.file_name?.substring(
                    list?.file_name?.lastIndexOf(".") + 1
                  ) : list?.file?.list?.file_name?.substring(list?.file_name?.lastIndexOf(".") + 1);
                  const fileExtensionDownload = list?.file?.type || list?.type;
                  const fileUrl = list?.file ? URL.createObjectURL(list?.file) : list?.media_file_name ? list?.media_file_name?.substring(
                    list?.file_name?.lastIndexOf(".") + 1
                  ) : ""
                  const allowedImageTypes = new Set(["jpg", "jpeg", "png", "gif", "webp", "avif", "svg"]);
                  const isImageType = allowedImageTypes.has(fileExtensionDownload);
                  return (
                    <Box key={index} className="flex flex-col flex-wrap">
                      <div className="w-[140px] h-[140px] border-2 object-cover overflow-hidden rounded-lg">
                        {(list instanceof File || list?.file) ? (
                          <>
                            {isImageType ? (
                              <PreviewImage
                                disable_show={false}
                                image_url={""}
                                image_create_obj_url={fileUrl}
                                render_image={
                                  <img
                                    className="w-full h-full object-cover"
                                    src={fileUrl || ""}
                                    alt={`img-${index}`}
                                  />
                                }
                              />
                            ) : (
                              <img
                                onClick={() => props.handleShowImageWithIndex && props.handleShowImageWithIndex(index)}
                                className="w-full h-full object-cover hover:opacity-60 cursor-pointer"
                                src={defaultFile}
                                alt={"default"}
                              />

                            )}
                          </>

                        ) : (
                          <>
                            {/* {console.log(`${image_url || pathUrl?.REACT_APP_BASE_API_PUBLIC}/` + list?.file_path,'`${image_url || pathUrl?.REACT_APP_BASE_API_PUBLIC}/` + list?.file_path')} */}
                            {list.is_image ? (
                              <PreviewImage
                                disable_show={false}
                                image_url={
                                  list?.media_file_path ?
                                    `${image_url}/${list?.media_file_path}${list?.media_file_name}` :
                                    `${image_url || pathUrl?.REACT_APP_BASE_API_PUBLIC}/` + list?.file_path}
                                render_image={
                                  <img
                                    className="w-full h-full object-cover cursor-pointer hover:opacity-70"
                                    src={
                                      list?.media_file_path ?
                                        `${image_url}/${list?.media_file_path}${list?.media_file_name}`
                                        : (image_url || pathUrl?.REACT_APP_BASE_API_PUBLIC) &&
                                        `${image_url || pathUrl?.REACT_APP_BASE_API_PUBLIC}/` + list?.file_path
                                    }
                                    alt={`img-${index}`}
                                  />
                                }
                              />
                            ) : (
                              <img
                                onClick={() =>
                                  props.handleDownloadFile &&
                                  props.handleDownloadFile(list)
                                }
                                className="w-full h-full object-cover hover:opacity-60 cursor-pointer"
                                src={defaultFile}
                                alt="default"
                              />
                            )}
                          </>
                        )}
                      </div>
                      <div className="flex justify-between items-center px-2 gap-1">
                        <Typography>
                          {" "}
                          {fileNameDownload || fileName || fileMediaName}.{fileExtensionDownload || fileExtension}
                        </Typography>
                        {props.onDownloadFileButton && (
                          <IconButton onClick={() => props.onDownloadFileButton && props.onDownloadFileButton(list)}>
                            <IconComponent.DownloadIcon />
                          </IconButton>
                        )}
                        {!props.disabled && (
                          <IconButton
                            onClick={() =>
                              props.handleDeleteImageApi(
                                props.tabIndex,
                                index,
                                list
                              )
                            }
                            sx={{ color: "#000", width: "10px", padding: "0" }}
                          >
                            <HighlightOffIcon sx={{ fontSize: "1.2rem" }} />
                          </IconButton>
                        )}
                      </div>
                    </Box>
                  );
                })}
              {props?.valueAddFile?.map((list: any, index: number) => {
                const file: any = list?.file;
                const fileName = file?.name?.substring(0, 6) + "../";
                const fileExtension = file?.name?.substring(
                  file?.name?.lastIndexOf(".") + 1
                );

                return (
                  <Box key={index} className="flex flex-col flex-wrap">
                    <div className="w-[140px] h-[140px] border-2 object-cover overflow-hidden rounded-lg">
                      {!list?.is_image ? (
                        <React.Fragment>
                          <img
                            onClick={() =>
                              window.open(URL.createObjectURL(file), "_blank")
                            }
                            className="w-full h-full object-cover hover:opacity-60 cursor-pointer"
                            src={defaultFile}
                            alt="default"
                          />
                        </React.Fragment>
                      ) : (
                        <PreviewImage
                          disable_show={false}
                          image_url={URL.createObjectURL(file)}
                          render_image={
                            <img
                              className="w-full h-full object-cover"
                              src={URL.createObjectURL(file) || ""}
                              alt={`img-${index}`}
                            />
                          }
                        />
                      )}
                    </div>
                    <div className="flex justify-between px-2 gap-1">
                      <Typography>
                        {" "}
                        {fileName}.{fileExtension}
                      </Typography>
                      {!props.disabled && (
                        <IconButton
                          onClick={() =>
                            props.handleDeleteImageSelect(props.tabIndex, index)
                          }
                          sx={{ color: "#000", width: "10px", padding: "0" }}
                        >
                          <HighlightOffIcon sx={{ fontSize: "1.2rem" }} />
                        </IconButton>
                      )}
                    </div>
                  </Box>
                );
              })}
            </>
          )}

          <label
            // htmlFor={uniqueId}
            onClick={props.onUploadMedia}
            htmlFor={uniqueId}
            className={`w-full max-w-[140px] h-full cursor-pointer ${props.disabled && "opacity-50 cursor-auto"
              }`}
          >
            <div className="w-full max-w-[140px] bg-light h-full min-h-[140px] flex justify-center items-center">
              {props.addImageIcon ? (
                <>
                  {props.addImageIcon}
                </>
              ) : (
                <AddCircleOutlineIcon
                  sx={{ fontSize: "calc(1vw + 7rem)", color: "#C1C3C7" }}
                  className="w-full"
                />
              )}
            </div>
            <div className="text-center">
              {!props.disabled && (
                <Typography sx={{ fontSize: ".9em" }}>{t("เพิ่มไฟล์")}</Typography>
              )}
            </div>
          </label>
        </ImageContainer>
        {props.is_using_modal_media ? (
          <></>
        ) : (
          <input
            disabled={isViewCheck || props.disabled}
            onChange={handleFileChange}
            multiple
            {...(props.enableAllType ? {} : { accept: "image/*" })}
            id={uniqueId}
            className="hidden"
            type="file"
          />
        )}
      </article>
    </section>
  );
};

export default ImageTracking;
